
 /* eslint-disable */
import React, { Component } from "react"
import _ from 'lodash'
import { PropTypes } from "prop-types"
import moment from 'moment'
import { bindActionCreators } from 'redux'
import { connect } from "react-redux"
import {  reduxForm, propTypes, reset,formValueSelector,change } from 'redux-form'
import { Row,Col,Button,Table,FormGroup,FormControl,InputGroup,ProgressBar,MenuItem,DropdownButton} from "react-bootstrap"
import Dialog from 'react-bootstrap-dialog'
import axios from 'axios'
import ModalWindow from '../../../utils/modalwindow'
import  { eventdefaults,forms,blue, orange,videoblue,warning, green,red } from '../../../utils/constants'
import { checkRole } from '../../../utils/helperfunctions'
import userManager from '../../../userManager'
import {URL} from '../../../config'
import ContentWrapper from "../../layout/ContentWrapper";
import EventWizard from "../../../containers/event/EventWizard/Wizard"
import {  fetchActiveSeasons,deleteEvent, copyEvent,enableUpload,resetEventWizard } from "../../../redux/actions/action_event"
import {  setUserRole} from "../../../redux/actions/action_user"
import '../../../utils/css/nospinner.css'

const EventStatusDesc = {
	InCompleteSetup:'Setup not completed',
	ComingUp:'Coming up',
	PendingResults:'Pending results upload',
	Completed:'Completed'
}
const SearchBy = {
	Name: 'name',
	Director: 'email',
	Status: 'status',
	Date: 'date',
	Membership: 'membership'
}
const biggerFont = {fontSize:'130%', fontWeight:'bold'}

const formName = forms.eventinfo

class Event extends Component {
   
  static propTypes = {
    ...propTypes
  }
  constructor(props)
  {
    super(props)   
    this.state = {
			addNewEventMode: false,  
			showSearchResultsMode: false,
			searchBy: SearchBy.Status,
			searchValue:'',
			freeTextSearch: false,
			searchResults:[],
			setupNotCompleted:0,
			pendingUpload:0,
			completedcurrent:0,
			comingup:0,
			searchMode:false,
			eventId:0,
			statusSearchValue:'all',
			roleChecked:false,
			viaInvitation:false
    }
    this.handleSearch      = this.handleSearch.bind(this)
    this.readSearchResults = this.readSearchResults.bind(this)
	this.handleValueChange = this.handleValueChange.bind(this)
	this.handleUpcominEvents = this.handleUpcominEvents.bind(this)
    this.handleViewEventDetails     = this.handleViewEventDetails.bind(this)
    this.handleSearchByStatusChange = this.handleSearchByStatusChange.bind(this)
    this.setStatusColor = this.setStatusColor.bind(this)
    this.resetEventPage = this.resetEventPage.bind(this)
    this.getEventStats  = this.getEventStats.bind(this)
    this.copyEvent      = this.copyEvent.bind(this)
	this.deleteEvent      = this.deleteEvent.bind(this)
	this.applyPermission =  this.applyPermission.bind(this)
	this.enableUpload = this.enableUpload.bind(this)
  }
  //#region Lyfecycle methods  
  componentDidMount() {
		const { oidc} = this.props
		const _this = this
	// console.log('Event setup componentDidMount oidc.user',oidc.user)
		if (oidc.user == null)
		{
			userManager.signinRedirect().then(function(user) {
				_this.applyPermission()
			})
		}
		else
		{
			this.getEventStats()
		}
  } 
  UNSAFE_componentWillReceiveProps = (nextProps)=> {
		if (nextProps.location.key !== this.props.location.key) 
		{
			this.setState(
			{
					addNewEventMode:false,
					eventId:0,
					searchResults:[]
			})
			this.props.dispatch(resetEventWizard())
		}
  }
  componentDidUpdate() {
		const {copiedEventId, dispatch,refreshDelete } = this.props
		if(copiedEventId != undefined & copiedEventId > 0)
		{
			this.handleViewEventDetails(copiedEventId)
			dispatch(change(formName,'copiedEventId',-1))
		}
		if((refreshDelete != undefined) && (refreshDelete === true)) {
			this.handleSearch()
		}
	}
	componentWillUnmount()
	{

	}
	//#endregion Lifecycle methods

	copyEvent(eventId) {
		const {dispatch,copyEvent} = this.props
			const event = {
				eventId
			}
			dispatch(copyEvent(event))
	}

	deleteEvent(eventId) 
	{
		const event = {
			eventId
		}
		const customBody = (
			<p>
				<i className="fa fa-exclamation-triangle text-danger" style={{color:'red'}}/>
				&nbsp;&nbsp;
				<span>Are you sure you want to delete this event? </span>
			</p>
		)

		Dialog.setOptions({
			defaultOkLabel: 'Delete Event',
			defaultCancelLabel: 'Cancel',
			primaryClassName: 'btn-danger'
		})
		Dialog.Action(
			'Delete Event',
			() => this.props.deleteEvent(event),
			'btn-danger'
		)
		this.dialog.show({
			body: customBody,
			title:'Confirm Event Deletion',
			actions: [
							Dialog.CancelAction(),
							Dialog.OKAction(() => this.props.deleteEvent(event))
			],
			bsSize: 'small'
	 })
   }
   enableUpload(eventId) 
   {
	   console.log("eventId: ",eventId)
	   const event = {
		   eventId
	   }
	   const customBody = (
		   <p>
			   <i className="fa fa-question-circle text-danger" style={{color:'blue'}}/>
			   &nbsp;&nbsp;
			   <span>Enable results upload for this event? </span>
		   </p>
	   )

	   Dialog.setOptions({
		   defaultOkLabel: 'OK',
		   defaultCancelLabel: 'Cancel',
		   primaryClassName: 'btn-success'
	   })
	   Dialog.Action(
		   'Enable Results Upload',
		   () => this.props.enableUpload(event),
		   'btn-primary'
	   )
	   this.dialog.show({
		   body: customBody,
		   title:'Confirm',
		   actions: [
						   Dialog.CancelAction(),
						   Dialog.OKAction(() => this.props.enableUpload(event))
		   ],
		   bsSize: 'small'
	})
  }   
  getEventStats() {
		const {isAdministrator} = this.props.user
		const {email} = this.props.oidc.user.profile.email
		const statsendpoint = `/stats/${email}/${isAdministrator}`
		let  eventURL =  `${URL.event}${statsendpoint}` 

		this.setState({  showSearchResultsMode :false })
			axios.get(eventURL)
			.then(response => {
					
				if (response.data) {
						const { notCompleted, pendingUpload,completed,comingUp } = response.data
						this.setState({  
									setupNotCompleted:notCompleted,
									pendingUpload:pendingUpload,
									completedcurrent:completed,
									comingup:comingUp
						})
				}
		})
}
resetEventPage() {
	this.setState({ 
			addNewEventMode: false,  
			showSearchResultsMode: false
	})
	this.getEventStats()  
} 
setStatusColor(status)
{
		switch(status)
		{
				case EventStatusDesc.InCompleteSetup:
				{
						return warning
				}
				case EventStatusDesc.ComingUp:
				{
						return videoblue
				}
				case EventStatusDesc.PendingResults:
				{
						return red
				}
				case EventStatusDesc.Completed:
				{
						return green
				}
		}    
}
readSearchResults(events) 
{
		if(events) {
				const results = []
				const { oidc } = this.props
				const userEmail = oidc.user ? oidc.user.profile.email: ''
        const {isAdministrator} = this.props.user


			events.map((event) => {
				const info = event.eventInfo

				if ((info.directorSsoemail.toLowerCase() == userEmail.toLowerCase()) || isAdministrator)
				{
					const result =  {
						id:info.eventId,
						tournamentname: info.name,
						city: info.centerAddress.city,
						state:info.centerAddress.state,
						center: info.centerName,
						startdate: info.startDate != null ? moment(info.startDate).format('MM/DD/YYYY') :'',
						enddate: info.endDate != null ? moment(info.endDate).format('MM/DD/YYYY'):'',
						tournamentdirector: info.directorName,
						phonenumber: info.directorPhoneNumber,
						status: event.status,
						missingDocs: "No",
						action: ".",
						statusSearchValue:'all'
				  }
				  results.push(result)
				}
			})
			this.setState({ searchResults:results })
		} 
} 
//#region Event handlers
handleValueChange(event)
{
		const searchValue = event.target.value
		this.setState({  searchValue,showSearchResultsMode: false  })
}
handleSearch()
{
		const { searchBy, searchValue, statusSearchValue } = this.state
		const { refreshDelete, dispatch} = this.props

		let searchCriteria = searchValue

		if(searchBy === SearchBy.Status) {
				searchCriteria = statusSearchValue
		}
		console.log('handleSearch ')
		const searchendpoint = `/search/${searchBy}/${searchCriteria}`
		let  eventURL = `${URL.event}${searchendpoint}`

		this.setState({  showSearchResultsMode :false,searchMode:true })
		
		if (refreshDelete === true){        
			dispatch(change(formName,'refreshDelete',false))
		}   

		axios.get(eventURL)
			.then(response => {
				
				if (response.data) {
				
					this.readSearchResults(response.data)
					this.setState({  showSearchResultsMode :true,searchMode:false })
				}
				}).catch((error) => {
				
					this.props.dispatch(change('eventinfo','norecordsfound',true))
					this.setState({  searchMode:false })
				})
}
handleAddEvent = () => {
		this.setState({
				addNewEventMode: true,
				showSearchResultsMode:false,
				eventId:0 
		})
	//	this.props.dispatch(reset(formName)) --IMPORTANT, removed and check
}

handleSearchByChange = (event) => {
				const searchby = event.target.value
				let freetextsearch = true

				if((searchby == SearchBy.Status))
				{
						freetextsearch  = false
				}
				this.setModes(false,false,freetextsearch,searchby)
				this.setState({  showSearchResultsMode :false ,searchValue:''})
}

handleSearchByStatusChange(event){
		const searchvalue = event.target.value
		this.setState({statusSearchValue:searchvalue})
}

handleSearchValueChange = () => {
	this.setState({
			addNewEventMode: false,
			showSearchResultsMode: false
	})
}

handleViewEventDetails(eventId) {
	console.log('handleViewEventDetails ',eventId)
	this.setState({addNewEventMode:true,showSearchResultsMode:false,eventId:eventId,viaInvitation:true})
}
handleUpcominEvents=() => {
	alert('upcoming')
}
//#endregion
//#region Supporting functions		
setModes = (neweventmode, searchresultmode, freetextsearch=null,searchby=null) => {
      this.setState({
        addNewEventMode: neweventmode,
        showSearchResultsMode: searchresultmode,
        freeTextSearch: freetextsearch !== null ? freetextsearch : this.state.freeTextSearch,
        searchBy: searchby !== null ? searchby : this.state.searchBy
      })
}

setSearchTextField = () => {
		const fldtype = 'text'
		return (<FormControl type={fldtype} placeholder={this.state.searchBy === SearchBy.Membership ? 'xxxxx-xxxxxxx' : 'Enter value'} style={{ minWidth:'270px' }} onChange={this.handleValueChange}/>)
}

setSearchDateField = () => {
	const fldtype = 'date'
	return (<FormControl type={fldtype} style={{ minWidth:'150px' }} className='unstyled' onChange={this.handleValueChange}/>)
}


setSelectValues = () => {
		const attrs = {
			name:'searchvalue',
			componentClass:'select',
			onChange: this.handleSearchValueChange ,
			style:{ minWidth:"200px"}
		}
		switch(this.state.searchBy)
		{
			case SearchBy.Status:
			{
				return(
					<FormControl {...attrs} defaultValue="all" onChange={this.handleSearchByStatusChange} style={{minWidth:'210px'}}>
						<option value="all">All</option> 
						<option value="setupnotcompleted">Setup not completed</option>  
						<option value="comingup">Upcoming events</option> 
						<option value="pendingresults">Pending uploads</option>          
						<option value="completed">Completed current season</option>                  
					</FormControl>
				)
			}
		}    
}

isFreeText = () => { return this.state.searchBy != SearchBy.All && this.state.searchBy != SearchBy.Date && this.state.freeTextSearch }

isSelect = () => { return this.state.searchBy == SearchBy.Status }

isDateField = () => { return this.state.searchBy == SearchBy.Date }
//#endregion
applyPermission()
{
	const { user } = this.props.oidc
	const { roleChecked } = this.props.user
    const { dispatch } = this.props
	
	if ((user != null) && (!roleChecked))
	{
		const token = user.access_token
		const _this = this

		checkRole(token).then(function(response) {
			 const isAdmin = response.data
			 dispatch(setUserRole(isAdmin))
       const ssoEmail  = _this.props.oidc.user.profile.email
       _this.getEventStats(ssoEmail,isAdmin)
		})
	}
}

render()
	{
			const { dispatch,  norecordsfound,match } = this.props
			const { setupNotCompleted,pendingUpload,completedcurrent,comingup, searchMode,
				eventId,searchBy,statusSearchValue,addNewEventMode,showSearchResultsMode,searchResults,viaInvitation 
			} = this.state
			
			const { isAdministrator } = this.props.user
			
			this.applyPermission()
			
			var id = match.params.id

			console.log('Event page norecords found', id)
		
			// check whether id. if id is provided must likely throuh a director invitation
		  if (id != undefined)
			{
				//console.log('Event render id', id)
				if(!viaInvitation)
				{
					this.handleViewEventDetails(id)
				}
			} 

			return (
				<ContentWrapper>
						<div className="content-heading" style={{marginBottom:'30px'}}>Event Setup</div>
						<Dialog  ref={(el) => { this.dialog = el }}  />
						{
							// client searched and no records were found
								norecordsfound && 
							(<ModalWindow 
									title='No records found' 
									message='We could not find any records matching the search criteria specified.' 
									trigger='norecordsfound'
									dispatch={dispatch} 
								/>)
						}  
					
					 	{ 
							!addNewEventMode &&     
							(<Row>
								<Col xs={12}>
										<div className="stacked-filter-panel">
											<FormGroup controlId="searchby" className="searchby-filter">
													<FormControl  defaultValue={SearchBy.Status} componentClass="select" placeholder="All" onChange = { this.handleSearchByChange } style={{ minWidth:'245px' }}>
														<option value={SearchBy.Date}>Date</option>
														<option value={SearchBy.Name}>Name</option>
														<option value={SearchBy.Status}>Status</option>
														{ isAdministrator ==  true && (<option value={SearchBy.Director}>Event director email</option>)}
														{ isAdministrator && (<option value={SearchBy.Membership}>Event director USBC Member ID</option>)}
													</FormControl>
													<InputGroup>
														{ !this.state.addNewEventMode && this.isFreeText() && this.setSearchTextField()}
														{ this.isSelect() && this.setSelectValues() }
														{ this.isDateField() && this.setSearchDateField()}
														{ this.isSelect() && (searchBy === SearchBy.Status)  && statusSearchValue == 'completed'}
														<InputGroup.Button>
																<Button onClick={this.handleSearch} style={{ color:orange, marginLeft:'-2px', minHeight:'36px' }} disabled={this.state.searchValue.length < 3 && searchBy != SearchBy.Status}>
																		<i className={ searchMode === true ? "fa fa-spinner fa-spin":"fa fa-search"} aria-hidden="true"  />
																</Button>
														</InputGroup.Button> 
														{
															isAdministrator && (<InputGroup.Button>
																<Button style={{ color:blue, minHeight:'36px' }} onClick={this.handleAddEvent} disabled={this.state.addNewEventMode}>
																		<i className="fa fa-calendar" aria-hidden="true"  />&nbsp;&nbsp; Add Event
																</Button>
														  </InputGroup.Button>)
													  }
													</InputGroup>
											</FormGroup>
										</div>
							</Col>
						</Row>)} 
								{ 
										!addNewEventMode && !showSearchResultsMode &&
										(
											<Row>
												<Col lg={3}>
													<div className="panel widget">
														<div className="panel-body">
															<h5 className="mt0">Setup Not Completed</h5>
															<div className="counter text-warning"><span style={this.biggerFont}>{setupNotCompleted}</span></div>
															<ProgressBar now={34} max={172} bsStyle="warning" />
														</div>
													</div>
												</Col>
												<Col lg={3}>
													<div className="panel widget" onClick={this.handleUpcominEvents}>
															<div className="panel-body">
																<h5 className="mt0">Upcoming Events</h5>
																<div className="counter text-primary"><span style={this.biggerFont}>{comingup}</span></div>
																<ProgressBar now={21} max={172} bsStyle="info" />
															</div>
													</div>
												</Col>
												<Col lg={3}>
													<div className="panel widget">
															<div className="panel-body">
																<h5 className="mt0">Pending Uploads</h5>
																<div className="counter text-danger"><span style={this.biggerFont}>{pendingUpload}</span></div>
																<ProgressBar now={21} max={172} bsStyle="danger" />
															</div>
													</div>
												</Col>
												<Col lg={3}>
													<div className="panel widget">
															<div className="panel-body">
																<h5 className="mt0">Completed Current Season</h5>
																<div className="counter text-success"><span style={this.biggerFont}>{completedcurrent}</span></div>
																<ProgressBar now={21} max={172} bsStyle="success" />
															</div>
													</div>
												</Col>
											</Row>
									)
								}
								{ 
									showSearchResultsMode && (<Row>
										<Col xs={12}>
												<Table striped>
														<thead>
															<tr>
																<th>Event Name</th>
																<th>Center</th>
																<th>City</th>
																<th>State</th>                       
																<th>Start Date</th>
																<th>End Date</th>
																<th>Director</th>
																<th>Phone Number</th>
																<th>Status</th>
																<th style={{ width: "30px" }}>Action</th>
															</tr>
														</thead>
														<tbody>
															{ searchResults && searchResults.map((item, key) => (																
																<tr key={key}>
																		<td>
																			{key + 1}{' .'} <Button className="btn btn-default" style={{color:blue}}  onClick={() => this.handleViewEventDetails(item.id)}>
																			{_.startCase(item.tournamentname)}
																			</Button>
																		</td>
																		<td>{item.center}</td>
																		<td>{item.city}</td>
																		<td>{item.state}</td>
																		<td>{item.startdate}</td>
																		<td>{item.enddate}</td>
																		<td>{item.tournamentdirector}</td>
																		<td>{item.phonenumber}</td>
																		<td><span style={{color:this.setStatusColor(item.status),fontSize:'90%'}}>{item.status}</span></td>                          
																		<td>
																			<DropdownButton  pullRight noCaret title={<i className="fa fa-angle-right" />} id={"cloneActionBtn" + key}>
																					{ 
																						<div style={{ textAlign:'center'}}>
																							<MenuItem eventKey={item.id} style={{marginLeft:'-10px'}}  onSelect={(e) => {
																								this.copyEvent(e)
																							}}>
																							<i className="fa fa-clone  text-muted mr-sm"  />&nbsp;Copy event
																							</MenuItem>
																							{/* hidden={(item.status !== 'Setup not completed') && (item.status !== 'Coming up')} */}
																							<MenuItem  eventKey={item.id}  onSelect={(e) => {
																								this.deleteEvent(e)
																							}}>
																								<i className="fa fa-trash-o  text-muted mr-sm" style={{ color:red}} />&nbsp;Delete event
																							</MenuItem>
                                          {isAdministrator == true &&
                                            <MenuItem eventKey={item.id} onSelect={(e) => {
                                              this.enableUpload(e)
                                            }}>
                                              <i className="fa fa-upload fa-fw mr-sm" />&nbsp;Enable upload
																							</MenuItem>
                                          }
																						</div>
																					}
																			</DropdownButton>
																		</td>
																</tr>
																	))}
														</tbody>
												</Table>
										</Col>
									</Row>)
								}
								{
										(addNewEventMode && <EventWizard eventId={eventId}  />)
								} 
		</ContentWrapper>        
					)
	}
}
Event.propTypes = {
  dispatch:PropTypes.func,
  reset:PropTypes.func,
  norecordsfound:PropTypes.bool,
  fetchActiveSeasons:PropTypes.func,
  deleteEvent:PropTypes.func,
  copyEvent:PropTypes.func,
  enableUpload:PropTypes.func,
  setUserRole:PropTypes.func,
  resetpage:PropTypes.bool,
  refreshDelete:PropTypes.bool,
  copiedEventId:PropTypes.number,
  oidc:PropTypes.object,
	user:PropTypes.object,
	resetEventWizard:PropTypes.func
}
function mapStateToProps(state,ownProps){

  const formName          =  ownProps.form
  const selector          = formValueSelector(formName)
  const norecordsfound    = selector(state,'norecordsfound')
  const refreshDelete     = selector(state,'refreshDelete')
  const copiedEventId     = selector(state,'copiedEventId')
 
  return {
    norecordsfound,
    refreshDelete,
		copiedEventId,
		oidc: { ...state.oidc },
		user:{...state.user}
  }
}
function mapDispatchToProps(dispatch){
  return bindActionCreators({
      fetchActiveSeasons,
      deleteEvent,
			copyEvent,
			enableUpload,
			setUserRole,
			resetEventWizard
    },dispatch)
}
export default reduxForm({
  form:formName,
  initialValues:eventdefaults,
  destroyOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(Event))




// WEBPACK FOOTER //
// ./src/components/pages/Event/index.js